class PageData {
  constructor(key, data, accessLevel) {
    this.key = key;
    this.data = data;
    this.accessLevel = accessLevel;
  }
}

export default PageData;
